"use client";

import { ThemeProvider as NextThemesProvider, useTheme } from "next-themes";
import * as React from "react";

// Mirror the theme into a cookie shared across *.somemath.com so meet/space open with the same theme.
function ThemeCookieSync() {
  const { theme } = useTheme();
  React.useEffect(() => {
    if (!theme) return;
    const domain = location.hostname.endsWith("somemath.com") ? "; domain=.somemath.com" : "";
    document.cookie = `theme=${theme}${domain}; path=/; max-age=31536000; samesite=lax`;
  }, [theme]);
  return null;
}

export function ThemeProvider({
  children,
  ...props
}: React.ComponentProps<typeof NextThemesProvider>) {
  return (
    <NextThemesProvider {...props}>
      <ThemeCookieSync />
      {children}
    </NextThemesProvider>
  );
}
